import React from "react";
import YouTube from "react-youtube";
import { useGalleryContext } from "../../../context/GalleryContext";
import { NoImageFeedback } from "./NoImageFeedback";
import { weightSorter } from "../../../helpers/sortUtils";

const WorkInAction = () => {
  const { videos } = useGalleryContext();

  if (!videos || videos.length === 0) {
    return (
      <div
        className="
          min-h-[200px] flex items-center justify-center
          p-4
        "
      >
        <NoImageFeedback text="emptyVideoText" />
      </div>
    );
  }
  return (
    <section className="w-full">
      <div className="maxContainer">
        <div className="grid items-center justify-center gap-8 mt-12 ss:grid-cols-2">
          {weightSorter([...videos]).map((video, index) => (
            <div
              className="flex justify-center w-full h-full min-h-[329px] bg-black"
              key={index}
            >
              <YouTube
                videoId={video.cloudPublicId}
                opts={{
                  height: "100%",
                  width: "100%",
                  playerVars: {
                    autoplay: 1,
                    mute: 1,
                    loop: 1,
                    playlist: video.cloudPublicId,
                  },
                }}
                className="w-full min-h-[329px]"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkInAction;
